import { TableRow } from 'altus-ui-components';

const FluidTableRow = ({ onRowClick, ...rest }) => {
  return <TableRow {...rest} onRowClick={onRowClick} />;
};

export default FluidTableRow;
